import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SettlementServiceService } from '../../../../services/raintree/Transmission/settlement-service.service';
import { ToastrService } from 'ngx-toastr';
import { MatIconModule } from '@angular/material/icon';
import { LoaderComponent } from '../../../../common-component/loader/loader.component';

@Component({
  selector: 'app-view-advance-details',
  standalone: true,
  imports: [MatIconModule,LoaderComponent],
  templateUrl: './view-advance-details.component.html',
  styleUrl: './view-advance-details.component.scss',
})
export class ViewAdvanceDetailsComponent {
  advanceAmountDetails: any[] = [];
  isLoading: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ViewAdvanceDetailsComponent>,
    private settlementService: SettlementServiceService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.getAllAdvance();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  getAllAdvance() {
    this.isLoading = true;
    const params = {
      mandirCode: this.data.mandirCode,
      fy: this.data.fy,
    };
    console.log('passing params', params);

    this.settlementService.getAdvanceDetails(params).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res) {
          this.advanceAmountDetails = res.data;
        }
        // this.toastr.success(res.message)
        console.log('data received from API for advance amount:', res.data);
      },
      error: (err) => {
        this.isLoading = false;
        this.toastr.error(err.message);
      },
    });
  }

  formatIndianCurrency(amount: string | number): string {
    const number = Number(amount);
    if (isNaN(number) || null) return '--';

    return (
      '₹ ' +
      number.toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  }
}
